import { useEffect, useRef } from 'react';

import type { FormInstance } from '@arco-design/web-react';

import { clearGpuFields } from '../domain/form';
import type { ComputePaths } from '../types';

/** 架构实际变更时清空 GPU 资源配置（不影响 CPU / 内存 / 镜像预置） */
export function useClearGpuOnArchitectureChange(form: FormInstance, paths: ComputePaths, architecture: string | undefined, enabled = true) {
  const previousArchitectureRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (!enabled) return;

    const previous = previousArchitectureRef.current;
    previousArchitectureRef.current = architecture;

    if (previous === undefined || previous === architecture) return;

    clearGpuFields(form, paths);
  }, [architecture, enabled, form, paths]);
}
